import {
  CommonModule,
} from '@angular/common';
import {
  NgModule,
} from '@angular/core';
import {
  MatButtonModule,
} from '@angular/material/button';
import {
  TrackEventsModule,
} from '@o3r/analytics';
import {
  LocalizationModule,
} from '@o3r/localization';
import {
  PricePipeModule,
} from '@refx/shared-common';
import {
  CustomBackToMmbPresModule,
} from 'src/customization/components/custom-back-to-mmb';
import {
  CustomRefundTeaserPresComponent,
} from './custom-refund-teaser-pres.component';

@NgModule({
  imports: [
    CustomBackToMmbPresModule,
    CommonModule,
    LocalizationModule,
    MatButtonModule,
    PricePipeModule,
    TrackEventsModule
  ],
  declarations: [CustomRefundTeaserPresComponent],
  exports: [CustomRefundTeaserPresComponent]
})
export class RefundTeaserPresModule {}
